import { AlertCircle } from 'lucide-react'
import { Button } from '../ui/button'
import { useTranslation } from 'react-i18next'
import { useErrorMessage } from '@/hooks/useErrorMessage'

export interface ErrorStateProps {
  error: Error | string | unknown
  title?: string
  onRetry?: () => void
}

export function ErrorState({ 
  error, 
  title,
  onRetry 
}: ErrorStateProps) {
  const { t } = useTranslation()
  const { getErrorMessage } = useErrorMessage()
  const errorMessage = getErrorMessage(error)

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center">
      <div className="rounded-full bg-destructive/10 p-4 mb-4">
        <AlertCircle className="h-12 w-12 text-destructive" />
      </div>
      
      <h2 className="text-2xl font-bold text-red-600 mb-2">
        {title || t('common.error')}
      </h2>
      
      <p className="text-gray-600 mb-4">
        {errorMessage}
      </p>

      <p className="text-sm text-gray-500 mb-6">
        {t("errorBoundary.contactSupport")}
      </p>

      {onRetry && (
        <Button onClick={onRetry} variant="outline">
          {t('common.retry')}
        </Button>
      )}
    </div>
  )
} 